module.exports = __webpack_public_path__ + "img/fj.16e18160.svg";